import React, { useState, useEffect } from 'react';
import Card from 'components_v2/common/CardV2/Card';
import Cookie from 'utils/cookies';
import Slider from 'react-slick';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import makeRequest from 'utils/makeRequest';
import { gaWrapper } from '../../../../../helpers/analytics';
import { TIMESCLUB_CTA_CAROUSEL } from '../../../../../constants';
import s from './TimesClubSlider.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

export default function TimesClubSlider(props) {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [updatedimgPixel, setImgPixel] = useState('');

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    autoplay: true,
  };
  const { ga4Type, imgPixel } = props;
  useEffect(() => {
    if (Cookie.get('geo_country') === 'US') {
      makeRequest
        .get(
          'https://timesofindia.indiatimes.com/feeds/timesclubiapi/feedtype-json.cms',
          {},
          'skipfeedengine',
        )
        .catch(err => console.log(err))
        .then(res => {
          if (
            res &&
            res.status === 200 &&
            res.data &&
            Array.isArray(res.data) &&
            res.data.length
          ) {
            const dt = res.data.filter((v, i) => i < 21);
            setData(dt);
            setShow(true);
            if (imgPixel) {
              const unixTimestamp = Date.now();
              const withNewData = imgPixel.replace('__TIME__', unixTimestamp);
              setImgPixel(withNewData);
            }
          }
        });
    }
  }, []);

  const onCTAClick = textLabel => {
    gaWrapper('send', 'event', 'TOI_US_TC', `click_tccar`);
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga4Type,
        label: textLabel,
        category: 'cta_click',
      });
    }
  };

  return (
    show && (
      <ElementInView gaCategory="TOI_US_TC" gaAction="view_tccar">
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: ga4Type,
              });
            }
          }}
        >
          <div className={s.Toiplus_stories}>
            <div className={s.leftcol}>
              <i className={s.logo} />

              <a
                href={TIMESCLUB_CTA_CAROUSEL}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={() => onCTAClick('Explore')}
                className={s.cta_click}
              >
                Explore
              </a>

              <div className={s.inlinewidget}>
                <span className={s.head}>Exclusive access to</span>
                <ul>
                  <li> Everyday cashbacks</li>
                  <li> Exclusive free rewards</li>
                  <li> $5 Sign up Bonus</li>
                </ul>

                <a
                  className={s.btn}
                  href={TIMESCLUB_CTA_CAROUSEL}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  onClick={() => onCTAClick('Start Earning Now!')}
                >
                  Start Earning Now!
                </a>
              </div>
            </div>
            <div className={`${s.rightcol} slick_UI`}>
              <Slider {...settings}>
                {data instanceof Array &&
                  data.map((item, index) => (
                    <div className={s.carosuel_card}>
                      <div className={s.carosuel_slide}>
                        <Card
                          data={item}
                          isVerticalTile
                          key={item.id || `${item.tn}_${index}`}
                          linkData={{
                            gaCategory: 'TOI_US_TC',
                            gaAction: 'click_tccar',
                          }}
                          ga4Type={ga4Type}
                          gaIndex={index + 1}
                          shouldNotlazyloadImage="false"
                        />
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
          {updatedimgPixel && (
            <img
              src={updatedimgPixel}
              border="0"
              width="1"
              height="1"
              alt="pixel_1x1"
            />
          )}
        </InViewObserver>
      </ElementInView>
    )
  );
}
